import React from "react";
import { Link } from "react-router-dom";

// Real TR monogram (public/logo-tr.png).
export const Logo = ({ className = "" }) => (
    <Link
        to="/"
        className={`inline-flex items-center ${className}`}
        data-testid="logo-link"
        aria-label="Tony Rays home"
    >
        <img loading="lazy" decoding="async"
            src="/logo-tr.png"
            alt="Tony Rays"
            className="h-20 w-auto md:h-28 object-contain"
        />
    </Link>
);
